import { render, staticRenderFns } from "./ProceDialog.vue?vue&type=template&id=580acaa4&scoped=true"
import script from "./ProceDialog.vue?vue&type=script&lang=js"
export * from "./ProceDialog.vue?vue&type=script&lang=js"
import style0 from "./ProceDialog.vue?vue&type=style&index=0&id=580acaa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580acaa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580acaa4')) {
      api.createRecord('580acaa4', component.options)
    } else {
      api.reload('580acaa4', component.options)
    }
    module.hot.accept("./ProceDialog.vue?vue&type=template&id=580acaa4&scoped=true", function () {
      api.rerender('580acaa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BasicsEnergyPrice/ProceDialog.vue"
export default component.exports